import { cn } from '../libs/tailwindMerge'

interface BadgeProps {
  title: string
  status: boolean
}

export function Badge({ title, status }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-1 font-medium ring-1 ring-inset mx-1 text-xs ',
        status
          ? 'bg-red-500 text-gray-50 ring-red-700/50'
          : 'bg-emerald-500 text-gray-50 ring-emerald-700/50',
      )}
    >
      {title}
    </span>
  )
}
